import { decodeResumeImprovement } from '@/models/Candidate/ResumeImprovement';
import { ServerApi } from '@/modules/api/server-api';

export const getCandidateCvImprovements = (api: ServerApi) => async () => {
  const response = await api.get('/v3/candidate/search-session/resume-improvements');
  return response.data && Array.isArray(response.data) ? response.data.map(decodeResumeImprovement) : [];
};
